<script setup>
import { computed } from 'vue'
import AssessmentActionEvaluation from './AssessmentActionEvaluation.vue'
import AssessmentActionRating from './AssessmentActionRating.vue'

const props = defineProps({
  action: {
    type: Object,
    default: undefined,
  },
  currentStep: {
    type: String,
    default: 'evaluation',
  },
  currentObjectiveKey: {
    type: String,
    default: undefined,
  },
  assessmentData: {
    type: Object,
    default: undefined,
  },
})

const actionEvaluationData = computed(() => {
  if (
    !props.assessmentData ||
    !props.assessmentData.evaluations[props.action.id]
  )
    return undefined
  return props.assessmentData.evaluations[props.action.id]
})

const actionRatingData = computed(() => {
  if (!props.assessmentData || !props.assessmentData.ratings[props.action.id])
    return undefined
  return props.assessmentData.ratings[props.action.id]
})

const actionTitle = computed(() => {
  if (
    !props.assessmentData ||
    !props.assessmentData.evaluations[props.action.id]
  )
    return props.action.title

  if (
    props.assessmentData.evaluations[props.action.id].customDefinition !=
      undefined &&
    props.currentStep == 'rating'
  )
    return props.assessmentData.evaluations[props.action.id].customDefinition

  return props.action.title
})
</script>

<template>
  <li class="AssessmentAction">
    <fieldset>
      <legend class="AssessmentAction-label">
        <span class="AssessmentAction-labelKey"
          >{{ currentObjectiveKey }}{{ props.action.key }}</span
        >
        {{ actionTitle }}
      </legend>

      <AssessmentActionEvaluation
        v-if="currentStep == 'evaluation'"
        :action="props.action"
        :version="actionEvaluationData?.version"
        :evaluation="actionEvaluationData?.value"
        :custom-definition="actionEvaluationData?.customDefinition"
        class="AssessmentAction-inputs"
      />

      <AssessmentActionRating
        v-if="currentStep == 'rating'"
        :action="props.action"
        :effort="actionRatingData?.effort"
        :effort-version="actionRatingData?.effortVersion"
        :impact="actionRatingData?.impact"
        :impact-version="actionRatingData?.impactVersion"
        class="AssessmentAction-inputs"
      />
    </fieldset>
  </li>
</template>
